import {resolutionList} from "../constants/resolutions";

/**
 * Calculates resolution time period
 * @param endTime             endTime in millisecond or dateTime string
 * @param resolution          resolution in seconds
 * @param numberOfDataPoints  number of data
 * @return object             ISO formatted resolution period {start, end}
 */
export const getResolutionPeriod = (endTime, resolution, numberOfDataPoints) => {
  const now = Date.now();

  if (typeof endTime === 'string') {
    endTime = new Date(endTime).getTime();
  }

  if (endTime > now) {
    endTime = now;
  }

  const startTime = endTime - (resolution * 1000 * numberOfDataPoints);

  return {
    start: new Date(startTime).toISOString(),
    end: new Date(endTime).toISOString()
  }
};

export const getResolutionPeriodByStartTime = (startTime, resolution, numberOfDataPoints) => {
  const now = Date.now();

  if (typeof startTime === 'string') {
    startTime = new Date(startTime).getTime();
  }

  let endTime = startTime + (resolution * 1000 * (numberOfDataPoints + 2));

  if (endTime > now) {
    endTime = now;
  }

  return {
    start: new Date(startTime).toISOString(),
    end: new Date(endTime).toISOString()
  }
};

export const findOptimalResolution = (startTime, endTime) => {
  const duration = endTime - startTime;
  const windowTime = duration / 2000;
  return resolutionList.find(r => r && r[1] * 1000 >= windowTime)
};




// WEBPACK FOOTER //
// ./src/core/utils/resolution.js